import Action from 'redux/helpers/createAction'
const name = 'websiteAudit'

export const loadDomains = Action(name + '/LOAD_DOMAINS')

export const loadDomainsSuccess = Action(name + '/LOAD_DOMAINS_SUCCESS', domains => ({
  domains
}))

export const loadDomainsFailure = Action(name + '/LOAD_DOMAINS_FAILURE', error => ({
  error
}))

export const sortDomainsAuditReport = Action(name + '/SORT_DOMAINS', (value, order) => ({
  value,
  order
}))

export const getAuditReport = Action(name + '/GET_AUDIT_REPORT', (domainId, auditId) => ({
  domainId,
  auditId
}))

export const getAuditReportSuccess = Action(
  name + '/GET_AUDIT_REPORT_SUCCESS',
  (data, domainId) => ({
    data,
    domainId
  })
)

export const getAuditReportFailure = Action(name + '/GET_AUDIT_REPORT_FAILURE', error => ({
  error
}))

export const getAuditCrawlData = Action(name + '/GET_AUDIT_CRAWL_DATA', (domainId, auditId) => ({
  domainId,
  auditId
}))

export const getAuditCrawlDataSuccess = Action(name + '/GET_AUDIT_CRAWL_DATA_SUCCESS', data => ({
  data
}))

export const getAuditCrawlDataFailure = Action(name + '/GET_AUDIT_CRAWL_DATA_FAILURE', error => ({
  error
}))

export const getCompareAuditReport = Action(
  name + '/GET_COMPARE_AUDIT_REPORT',
  (domainId, auditId) => ({
    domainId,
    auditId
  })
)

export const getCompareAuditReportSuccess = Action(
  name + '/GET_COMPARE_AUDIT_REPORT_SUCCESS',
  data => ({
    data
  })
)

export const getCompareAuditReportFailure = Action(
  name + '/GET_COMPARE_AUDIT_REPORT_FAILURE',
  error => ({
    error
  })
)

export const getAllAuditReports = Action(name + '/GET_ALL_AUDIT_REPORTS', domainId => ({
  domainId
}))

export const getAllAuditReportsSuccess = Action(name + '/GET_ALL_AUDIT_REPORTS_SUCCESS', data => ({
  data
}))

export const getAllAuditReportsFailure = Action(name + '/GET_ALL_AUDIT_REPORTS_FAILURE', error => ({
  error
}))

export const exportAuditReport = Action(name + '/EXPORT_AUDIT_REPORT', (domainId, auditId) => ({
  domainId,
  auditId
}))

export const exportAuditReportSuccess = Action(name + '/EXPORT_AUDIT_REPORT_SUCCESS')

export const exportAuditReportFailure = Action(name + '/EXPORT_AUDIT_REPORT_FAILURE', error => ({
  error
}))

export const generateSitemapXML = Action(name + '/GENERATE_SITEMAP_XML', (domainId, auditId) => ({
  domainId,
  auditId
}))

export const generateSitemapXMLSuccess = Action(name + '/GENERATE_SITEMAP_XML_SUCCESS')

export const generateSitemapXMLFailure = Action(name + '/GENERATE_SITEMAP_XML_FAILURE', error => ({
  error
}))

export const restartAudit = Action(name + '/RESTART_AUDIT', (domainId) => ({
  domainId
}))

export const restartAuditFailure = Action(name + '/RESTART_AUDIT_FAILURE', error => ({
  error
}))
